module.exports = __webpack_public_path__ + "static/media/xiaochengxu.f87182d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/xiaochengxu.jpg
// module id = 128
// module chunks = 6